/** "messenger" module DTOs' unique keys */
export enum MessengerDtoKeysEnum {
  /** Commentary between list API query parameters */
  COMMENTARY_BETWEEN_QUERY_DTO = 'messenger/commentary-between-query.dto',
  /** Commentary create request body */
  COMMENTARY_CREATE_DTO = 'messenger/commentary-create.dto',
  /** Commentary response body */
  COMMENTARY_FIND_DTO = 'messenger/commentary-find.dto',
  /** Commentary page API query parameters */
  COMMENTARY_PAGE_QUERY_DTO = 'messenger/commentary-page-query.dto',
  /** Commentary page API response body */
  COMMENTARY_PAGE_DTO = 'messenger/commentary-page.dto',
  /** Commentary create/update request body */
  COMMENTARY_FORM_DTO = 'messenger/commentary-form.dto',
  /** Commentary send target response body */
  COMMENTARY_TARGET_DTO = 'messenger/commentary-target.dto',
  /** Thread response body */
  THREAD_FIND_DTO = 'messenger/thread-find.dto',
  /** Thread create/update request body */
  THREAD_FORM_DTO = 'messenger/thread-form.dto',
  /** Thread participant internal and external users who can be mentioned via `@...` */
  THREAD_PARTICIPANTS_DTO = 'messenger/thread-participants.dto',
}
